import { Card, CardBody, Loading } from "@dgs/core";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { eventService } from "../../shared/api/event/eventService";
import { EventAnalyticsFilterValues, EventBudgetAnalyticsResource } from "../analyticsTypes";
import { mapAnalyticsFilterValuesToRequest } from "../shared";
import { CostsByCategories } from "./CostsByCategories";
import { CostsOverview } from "./CostsOverview";

const EmptyCardBody = styled(CardBody)`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 500px;
	width: 100%;
`;

interface Props {
	filter: EventAnalyticsFilterValues;
}

function hasNoEventData(data: EventBudgetAnalyticsResource) {
	return (
		data.acceptedUserRequestCosts.length === 0 && data.contactCosts.length === 0 && data.costsByCategory.length === 0
	);
}

export function BudgetAnalytics({ filter }: Props) {
	const { t } = useTranslation();
	const { data, isLoading } = useQuery({
		queryFn: () => eventService.budgetAnalytics(mapAnalyticsFilterValuesToRequest(filter)).then((r) => r.data.data),
		queryKey: [...eventService.budgetAnalyticsKey, filter],
	});

	if (!data || isLoading) {
		return <Loading />;
	}

	if (hasNoEventData(data)) {
		<Card>
			<EmptyCardBody>
				<span>{t("No data is available.")}</span>
			</EmptyCardBody>
		</Card>;
	}

	return (
		<>
			<CostsOverview totalEventCosts={data.totalEventCosts} averageCostsPerEvent={data.averageCostsPerEvent} />
			<CostsByCategories
				costsByCategory={data.costsByCategory}
				contactCosts={data.contactCosts}
				acceptedUserRequestCosts={data.acceptedUserRequestCosts}
			/>
		</>
	);
}
